module.exports = __webpack_public_path__ + "img/man-stand.32c13e08.png";